export function windowVoiceflowChat(throwIfAbsent: boolean = true) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const asWindowWithWF = window as Window & { voiceflow?: any }
  const chat = asWindowWithWF.voiceflow?.chat
  if (!chat && throwIfAbsent) {
    throw new Error('voiceflow chat not present')
  }

  return chat
}
